import React, { useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import CommonLabel from '../commonLabel/CommonLabel';
import './Dropdown.css';

const DropdownNew = ({
  placeholder,
  label,
  isRequired = false,
  dataSet,
  getOptionLabel = 'label',
  getOptionValue = 'value',
  selectedValue,
  onSelectedValueChange,
  menuHeight = 150,
  controlShouldRenderValue = true,
  errMessage = 'This field is Required.',
  validity = false,
  isDisabled = false
}: {
  placeholder?: any;
  label?: any;
  isRequired?: boolean;
  dataSet: any;
  getOptionLabel: any;
  getOptionValue: any;
  selectedValue: any;
  onSelectedValueChange: any;
  menuHeight?: any;
  controlShouldRenderValue?: boolean;
  errMessage?: any;
  validity?: boolean;
  isDisabled?: boolean;
}) => {
  const [isValid, setIsValid] = useState<any>(null);

  function check(val: any) {
    let a: any = null;
    dataSet?.map((val1: any) => {
      if (val1[getOptionValue] == val) {
        a = val1;
      }
    });
    return a;
  }

  function checkValidation() {
    if (isRequired) {
      if (selectedValue) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    } else {
      setIsValid(true);
    }
  }

  const dataList = useMemo(() => {
    let obj: any = {};
    obj[getOptionLabel] = 'Select';
    obj[getOptionValue] = '';
    return [obj, ...dataSet];
  }, [dataSet]);

  useEffect(() => {
    if (validity) {
      checkValidation();
    }
  }, [validity, selectedValue]);

  return (
    <>
      <CommonLabel label={label} isRequired={isRequired} />
      <div className='mt-0 new-drop'>
        <Select
          className={isValid ? 'valid' : isValid === false ? 'invalid' : ''}
          options={dataSet ? dataList : []}
          getOptionLabel={(option: any) => option[getOptionLabel]}
          getOptionValue={(option: any) => option[getOptionValue]}
          controlShouldRenderValue={controlShouldRenderValue}
          value={check(selectedValue)}
          onChange={(e) => onSelectedValueChange(e[getOptionValue])}
          maxMenuHeight={menuHeight}
          menuPlacement='auto'
          menuShouldScrollIntoView={true}
          placeholder={placeholder}
          isDisabled={isDisabled}
          //   isSearchable
        />
      </div>
      <div className='errmsg'>{isValid === false ? errMessage : ''}</div>
    </>
  );
};
export default DropdownNew;
